const config = {
  // 项目名称
  source:'mbp', //使用平台
  userId: '', //用户信息
  //上报地址
  reportUrl: 'http://localhost:3001/report/actions',
  //是否全埋点
  trackerAll: false,
};

export let version = '';

export default config;

export function setConfig(options) { 
  for (const key in config) { 
    if (options[key]) { 
      config[key] = options[key];
    }
  }
  if(options['version']){
    version = options['version'];
  }
}
